
import Battery1full from "../../../assets/outline/Battery1full.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Battery1fullIcon({ className, dataTestid = "Battery1fullIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Battery1full data-testid={dataTestid} className={classes} {...rest} />
  );
}
